// removed by extract-text-webpack-plugin
module.exports = {"base":"SlideInner_base--3o4tI","slideContainer":"SlideInner_slideContainer--3cJMz","slideHeader":"SlideInner_slideHeader--3Lbue","description":"SlideInner_description--GNaqo","slideMessage":"SlideInner_slideMessage--Mb8rS"};


//////////////////
// WEBPACK FOOTER
// ./containers/Landing/components/SlideInner/SlideInner.scss
// module id = 2291
// module chunks = 11